module.exports = __webpack_public_path__ + "media/images/front/sp/default/noimage_s90x90-ff7be1788a0ccc44e27028072f2f23de.png";